export const DELETED_USERS_PARAM = 'usuarios_deletados';

export const EVENT_TRACKING = {
  appFeature: 'iclinic_downsell',
  appId: 'iclinic_web',
};
